import React from "react";
import { InputSwitch } from "primereact/inputswitch";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import * as styles from "./SubStationsInputs.module.css";

const SubStationsInputs = ({
  subStationInputs,
  minSubStationInputs,
  onChangeSubStationName,
  onChangeSubStationActive,
  onSelectSubStationImage,
  onAddSubStationInput,
  onRemoveSubStationInput,
  getImageUrl,
}) => {
  return (
    <div className="field">
      <label>Sub-station names (min 2)</label>
      <div className="flex flex-column gap-2">
        {subStationInputs.map((value, index) => (
          <React.Fragment key={`sub-station-${index}`}>
            {index > 0 && <hr className={styles.divider} />}
            <div
              className="flex gap-2 align-items-start"
            >
            <div className={styles.fullWidth}>
              <InputText
                value={value.name}
                onChange={(e) => onChangeSubStationName(index, e.target.value)}
                placeholder={`Sub-station ${index + 1}`}
                className={`w-full mb-3 ${styles.input}`}
              />

              <div className={`mt-2 ${styles.controlsColumn}`}>
                <div className={styles.switchWrapper}>
                  <InputSwitch
                    checked={!!value.active}
                    onChange={(e) => onChangeSubStationActive(index, e.value)}
                  />
                  <span style={{ marginLeft: 8 }}>
                    {value.active ? "Active" : "Inactive"}
                  </span>
                </div>

                <div>
                  <FileUpload
                    className={styles.substationFile}
                    mode="basic"
                    accept="image/*"
                    customUpload
                    uploadHandler={() => {}}
                    onSelect={(e) => onSelectSubStationImage(index, e)}
                    chooseLabel="Select image"
                  />
                </div>

                {value.preview || value.image_name ? (
                  <div
                    className={styles.preview}
                    style={{
                      backgroundImage: `url(${value.preview || (value.image_name ? getImageUrl(value.image_name) : "")})`,
                    }}
                  />
                ) : null}
              </div>
            </div>

            <Button
              type="button"
              icon="pi pi-minus"
              className={`p-button-text ${styles.removeSubstationBtn}`}
              onClick={() => onRemoveSubStationInput(index)}
              disabled={subStationInputs.length <= minSubStationInputs}
            />
          </div>
          </React.Fragment>
        ))}
        <div className={styles.addSubstationWrapper}>
          <Button
            type="button"
            icon="pi pi-plus"
            label="Add sub-station"
            className={`p-button-text ${styles.addSubstationBtn}`}
            onClick={onAddSubStationInput}
          />
        </div>
      </div>
    </div>
  );
};

export default SubStationsInputs;
